import { render, staticRenderFns } from "./SalesStatistics.vue?vue&type=template&id=3da6bfe3&scoped=true&"
import script from "./SalesStatistics.vue?vue&type=script&lang=js&"
export * from "./SalesStatistics.vue?vue&type=script&lang=js&"
import style0 from "./SalesStatistics.vue?vue&type=style&index=0&id=3da6bfe3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da6bfe3",
  null
  
)

export default component.exports